import { PageMeta } from "../app/PageMeta";
import { Footer } from "../components/Footer/Footer";
import { Header } from "../components/Header/Header";

export function NotFoundPage() {
  return (
    <>
      <PageMeta
        title="ページが見つかりません｜松島オート"
        description="お探しのページは見つかりませんでした。松島オートのトップページからご確認ください。"
        robots="noindex, nofollow"
      />
      <Header />
      <main id="main-content" className="not-found-page" tabIndex={-1}>
        <div className="section-shell not-found-page__inner">
          <p className="section-kicker">404 Not Found</p>
          <h1>ページが見つかりません</h1>
          <p>お探しのページは見つかりませんでした。</p>
          <a className="button not-found-page__link" href="/">
            トップページへ戻る
          </a>
        </div>
      </main>
      <Footer />
    </>
  );
}
